import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@convex/_generated/dataModel";
import { PlayersScreen } from "@/features/night/players/PlayersScreen";

export const Route = createFileRoute("/_authenticated/leagues/$leagueId/players/")({
  component: LeaguePlayersPage,
});

/** League players browser — night-theme redesign wired to live data. */
function LeaguePlayersPage() {
  const { leagueId } = Route.useParams();
  return <PlayersScreen leagueId={leagueId as Id<"leagues">} />;
}
